import { useState } from "react";

import { Card } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ToastProvider";
import { post } from "@/lib/api";

export function MerchPromoPanel() {
  const { push } = useToast();
  const [payload, setPayload] = useState(
    JSON.stringify(
      {
        items: [
          { name: "Vintage hoodie", type: "restock" },
        ],
      },
      null,
      2,
    ),
  );
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const handlePromote = async () => {
    setLoading(true);
    try {
      const parsed = JSON.parse(payload);
      const response = await post("/marketing/merch/promote", parsed);
      setResult(response);
      push({ title: "Merch promo queued", message: `Created ${response.promotions?.length ?? 0} promos.` });
    } catch (error) {
      push({
        title: "Invalid merch payload",
        message: error instanceof Error ? error.message : "Fix JSON and retry.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="space-y-3 border-border/70 bg-background/40 p-4">
      <p className="text-sm font-semibold text-foreground">Merch Promotion Engine</p>
      <Textarea
        value={payload}
        onChange={(event) => setPayload(event.target.value)}
        className="h-40 bg-background/40 text-foreground"
      />
      <Button onClick={() => void handlePromote()} disabled={loading}>
        {loading ? "Building…" : "Build promos"}
      </Button>
      {result ? (
        <div className="text-xs text-muted-foreground">
          <p>Status: {result.status}</p>
          {(result.promotions ?? []).map((promo: any) => (
            <p key={promo.item}>{promo.item}: {promo.platforms?.join(", ")}</p>
          ))}
        </div>
      ) : null}
    </Card>
  );
}
